import { events, INIT_EVENT, INIT_EVENT_FINISH } from '@/events-bus';
import { editor } from '@/instance';
import { useStoreActions } from '@/store';

export const useInitEditorStore = () => {
    const destroys: (() => void)[] = [
        useStoreActions((actions) => actions.templateModel.destroy),
        useStoreActions((actions) => actions.collapseModel.destroy),
        useStoreActions((actions) => actions.svipWatermarkModel.destroy),
        useStoreActions((actions) => actions.recordModel.destroy),
        useStoreActions((actions) => actions.saveInfoModel.destroy),
        useStoreActions((actions) => actions.searchModel.destroy),
        useStoreActions((actions) => actions.navigationCollapseModel.destroy),
        useStoreActions((actions) => actions.imageEditorModel.destroy),
        useStoreActions((actions) => actions.adjustCollapseModel.destroy),
    ];

    return {
        init() {
            events.emit(INIT_EVENT);
            editor.init();
            destroys.forEach((init) => {
                init();
            });
            events.emit(INIT_EVENT_FINISH);
        },
    };
};
